import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd15f9c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "panel-heading" }
const _hoisted_3 = { class: "buttons are-small" }
const _hoisted_4 = ["title", "disabled"]
const _hoisted_5 = { class: "icon is-small" }
const _hoisted_6 = {
  key: 0,
  class: "panel-block",
  style: {"display":"block"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "icon is-small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_AlteriPanelEntry = _resolveComponent("AlteriPanelEntry")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.t("contacts")), 1),
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("button", {
          class: "button",
          title: _ctx.t('addcontact'),
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addAlter && _ctx.addAlter(...args)), ["stop"])),
          disabled: !_ctx.isAlterOpsAllowed
        }, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, { icon: "user-plus" })
          ])
        ], 8, _hoisted_4)
      ])
    ]),
    (_ctx.alteri.length < 1)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.t("nocontactsyet1")), 1),
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.t("nocontactsyet2")) + " ", 1),
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_font_awesome_icon, { icon: "user-plus" })
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.t("nocontactsyet3")), 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alteri, (alter, i) => {
      return (_openBlock(), _createBlock(_component_AlteriPanelEntry, {
        key: alter.id,
        alter: alter,
        alterIndex: i,
        mapclicked: _ctx.mapclicked
      }, null, 8, ["alter", "alterIndex", "mapclicked"]))
    }), 128))
  ]))
}